import { ExternalLink } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";

import { Badge } from "@/components/ui/badge";

import type { Contact, LeadStatus } from "../types";

const leadStatusLabels: Record<LeadStatus, string> = {
  new: "New",
  qualified: "Qualified",
};

export const LeadStatusBadge = ({
  leadStatus,
  converted,
}: {
  leadStatus?: LeadStatus | null;
  converted?: boolean;
}) => {
  const translate = useTranslate();

  if (converted) {
    return (
      <Badge variant="secondary">
        {translate("resources.contacts.filters.converted", {
          _: "Converted",
        })}
      </Badge>
    );
  }

  const status: LeadStatus = leadStatus === "qualified" ? "qualified" : "new";

  return (
    <Badge variant={status === "qualified" ? "default" : "outline"}>
      {translate(`resources.contacts.filters.${status}`, {
        _: leadStatusLabels[status],
      })}
    </Badge>
  );
};

export const ConvertedProjectLink = ({
  projectId,
}: {
  projectId: Contact["converted_project_id"];
}) => {
  const translate = useTranslate();

  if (projectId == null) return null;

  return (
    <Link
      to={`/projects/${projectId}/show`}
      className="inline-flex shrink-0 items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      onClick={(event) => event.stopPropagation()}
    >
      <ExternalLink className="size-3" />
      {translate("resources.contacts.converted_project", {
        _: `Project #${projectId}`,
        projectId,
      })}
    </Link>
  );
};
